import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { useSchemeContext } from '@osmosis/react-ui/context/SchemeContext';
import { useState } from 'react';
import { P } from '@osmosis/react-ui/components/Text';
import { ExplanationDropDown, ExplanationMessage } from '../utils';
import { QuizExplanationObject } from '../../../../types/quiz';

/**
 * AnswerItem.
 */
export const AnsweredItem = ({
  text,
  explanation,
}: {
  text: string;
  explanation: string | QuizExplanationObject;
}) => {
  const color = useColors();
  const { scheme } = useSchemeContext();
  const [exp, setExp] = useState(false);

  return (
    <Box sx={{ borderBottom: `1px solid ${color.gray20}` }}>
      <Flex
        data-testid="answered-item"
        sx={{
          listStyle: 'none',
          padding: '10px',
          display: 'flex',
          justifyContent: 'space-between',
          background: scheme === 'dark' ? color.dark : color.white,
          flexDirection: 'column',
          alignItems: 'start',
        }}
        as="li"
      >
        <P dangerouslySetInnerHTML={{ __html: text }} mb={1} />
        {explanation && (
          <ExplanationDropDown isOpen={exp} setExplanationVisible={setExp} />
        )}
      </Flex>
      {exp && explanation && (
        <Box
          sx={{
            padding: '10px',
            margin: '10px',
            backgroundColor: color.gray5,
            borderRadius: '5px',
          }}
        >
          <ExplanationMessage explanation={explanation} />
        </Box>
      )}
    </Box>
  );
};
